import {env} from '../../../../environment'
import { ProductData, ProductMaterial } from '../../../types'
import { getCurrencyIso } from '../../../utils/CountrySelection'

const getNextYearInYYYYMMDDFormat = () => {
  const newDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1))
  const year = newDate.getFullYear()
  const month = newDate.getMonth()
  const day = newDate.getDay()

  return `${year}-${month}-${day}`
}

export function generateJsonLdForContact() {
  const jsonLd = {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    url: env.getBaseUrl(),
    contactPoint: [
      {
        '@type': 'ContactPoint',
        telephone: '+49-2236-3299695',
        contactType: 'customer service',
        areaServed: ['DE', 'AT', 'CH', 'DK', 'GB'],
        availableLanguage: ['German', 'English'],
      },
    ],
  }

  return jsonLd
}

export function generateJsonLdForProduct(
  productData: ProductData | null | undefined,
  sku: string,
  chosenMaterial: ProductMaterial,
  priceCountry: string,
  imageUrls: string[],
  url: string,
) {
  if (!productData) {
    return null
  }

  if (imageUrls.length == 0) {
    return null
  }

  const productJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    brand: {
      '@type': 'Brand',
      name: 'artboxONE',
    },
    sku: sku,
    description: productData.description,
    image: imageUrls[0],
    name: productData.name + ' (' + chosenMaterial.name + ')',
    offers: {
      '@type': 'Offer',
      url: url,
      priceCurrency: getCurrencyIso(priceCountry),
      price: chosenMaterial.price[priceCountry],
      priceValidUntil: `${getNextYearInYYYYMMDDFormat()}`,
      availability: chosenMaterial.out_of_stock
        ? 'http://schema.org/OutOfStock'
        : 'http://schema.org/InStock',
    },
  }

  return productJsonLd
}
